/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/react-in-jsx-scope */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FormInscription from '../components/Form/FormInscription';
import { withApollo } from '../lib/withApollo';

const IndexPage = () => {
  const queryClient = new QueryClient();

  // TODO: FIX PARA SOLO MOSTRAR ACTIVOS O DEFAULT?

  const themeLiffa = {
    id: 'liffa',
    colors: {
        primary: '#2c532e',
        border: '#5F8F49',
        background: '#192f1a',
        text: '#F5E07C',
    },
    pasarela_pagos: 'mercado_pago',
  };

  return (
    <QueryClientProvider client={queryClient}>
      <div id="container">
        <Header />
        <div id="logo_gde">
          <img title="LIFFA CLUB" src="/img/logo-liffa-fut-gde.png" />
        </div>
        <div className="content-wrapper-center row container-fluid p-left-right-0 m-left-right-0">
          <div className="col-md-3 p-left-right-0">
            <div className="col-md-12 sliderMenu p-30 bg-gray">
              <FormInscription filtroTorneo={['APERTURA 2026', 'TORNEO DE VERANO 2026', 'CLAUSURA 2026']} theme={themeLiffa}/>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </QueryClientProvider>
  );
};

export default withApollo({ ssr: true })(IndexPage);

// enable the line below for client side rendering of <TodoPrivateWrapper />
// export default withApollo()(IndexPage)
